import type { ConnectProto } from "@racoon/api";

// The job's own «Кол-во контейнеров»; jobs saved before the field fall back to their group's.
export const plannedContainerCount = (job: ConnectProto.Job): number =>
  job.numberOfContainers || job.containerGroup?.numberOfContainers || 0;
